import { redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { fetchSession, sessionQueryKey } from "./auth";
import { mayAccess, type Access } from "./access";

/**
 * A route's `beforeLoad` gate on a right (Beheer › Rechten, docs/auth.md). Without
 * it, a bookmark or an old link to a screen the user may not open showed that
 * screen's error ("kon niet worden geladen") because the API answered 403. Not
 * being allowed is not a failure: back to the dashboard, which everyone may open.
 *
 * An affordance only — the API enforces the same right regardless. The session is
 * cached by the _shell guard, so this resolves at once.
 */
export function requireAccess(access: Access) {
  return async ({ context }: { context: { queryClient: QueryClient } }) => {
    const session = await context.queryClient.ensureQueryData({ queryKey: sessionQueryKey, queryFn: fetchSession });
    if (!mayAccess(session, access)) throw redirect({ to: "/dashboard" });
  };
}
